/* Motion bundle builder.

   Decisions in order: size, mattress, firmness where the model has one, base,
   buy. Everything reprices live from BUNDLE, which is generated from the
   store's own variant data, so no price in this file is typed by hand.

   The reveal uses a CSS radial-gradient mask driven by two custom properties
   rather than the canvas approach on the product page. Ten cards each painting
   a canvas per frame would not hold 60fps, whereas a gradient mask composites
   on the GPU and costs nothing. Pointer driven where there is a real pointer,
   and on touch each card sweeps once as it scrolls into view so a phone still
   sees inside every mattress. */

(function () {
  /* Both the catalogue blob and the Liquid config that decorates it with plate
     urls and discount codes land asynchronously, so wait for a fully assembled
     BUNDLE rather than assuming script order. */
  function boot(tries) {
    if (window.BUNDLE && typeof window.BUNDLE.plate !== "function" && typeof window.mbApply === "function") window.mbApply();
    if (!window.BUNDLE || typeof window.BUNDLE.plate !== "function") {
      if ((tries || 0) > 2000) { if (window.console) console.error("Motion bundle: catalogue did not load"); return; }
      return setTimeout(function () { boot((tries || 0) + 1); }, 30);
    }
    if (window.__mbRan) return;
    window.__mbRan = true;
    run(window.BUNDLE);
  }

  function run(B) {

  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => [...(r || document).querySelectorAll(s)];
  const money = (n) => "$" + Number(n).toLocaleString("en-AU");
  const esc = (t) => String(t == null ? "" : t).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

  const firstAvailableSize = (m) => B.sizes.find((s) => m.bySize[s]);

  /* sides, mattress2, firmness2 and active only count on a Split King set to
     "Different each side". Side one is always mattress and firmness, so every
     other size and "Same on both sides" read exactly what they always have. */
  const SK = "Split King";
  const S = { size: "Queen", mattress: null, firmness: null, base: null, sides: "same", mattress2: null, firmness2: null, active: 1, autoSwitch: true, leftChosen: false, rightChosen: false };
  S.mattress = (B.mattresses.find((m) => m.bySize[S.size]) || B.mattresses[0]).handle;
  S.base = (B.bases[1] || B.bases[0]).handle;

  /* A visitor can arrive preselected, either from the quiz handing back a match
     or from an ad linking straight to a configuration. */
  (function fromUrl() {
    const q = new URLSearchParams(location.search);
    if (!q.get("size") && !q.get("mattress")) {
      let saved = null;
      try { saved = sessionStorage.getItem("mb_build"); } catch (e) {}
      if (saved) new URLSearchParams(saved).forEach((v, k) => { if (!q.has(k)) q.set(k, v); });
    }
    const size = q.get("size");
    const mat = q.get("mattress");
    const bas = q.get("base");
    const firm = q.get("firmness");
    if (size && B.sizes.includes(size)) S.size = size;
    if (mat && B.mattresses.some((m) => m.handle === mat && m.bySize[S.size])) S.mattress = mat;
    if (bas && B.bases.some((b) => b.handle === bas)) S.base = bas;
    if (firm) S.firmness = firm;
    /* sides=2 opens a Split King on "Different each side", which is how the kit
       pages hand over a couple who want another mattress on one side. mattress is
       side one and mattress2 side two; a side left out starts as the other one. */
    if (q.get("sides") === "2" && S.size === SK) {
      const mat2 = q.get("mattress2");
      const firm2 = q.get("firmness2");
      const named2 = !!mat2 && B.mattresses.some((m) => m.handle === mat2 && m.bySize[SK]);
      S.sides = "each";
      S.mattress2 = named2 ? mat2 : S.mattress;
      S.firmness2 = firm2 || (named2 ? null : S.firmness);
      /* the left side is already chosen when the link names it, so the next card is the right side */
      if (mat && S.mattress === mat) { S.active = 2; S.autoSwitch = false; S.leftChosen = true; }
      if (named2) S.rightChosen = true;
    }
  })();

  /* bundle-ux 2026-10-16: every change rewrites the address with the params fromUrl reads, so Back from the
     cart, checkout or a product page brings the same bed back instead of a fresh Queen. */
  function saveUrl() {
    try {
      const q = new URLSearchParams(location.search);
      q.set("size", S.size);
      if (S.mattress) q.set("mattress", S.mattress); else q.delete("mattress");
      if (S.base) q.set("base", S.base); else q.delete("base");
      if (S.firmness) q.set("firmness", S.firmness); else q.delete("firmness");
      if (S.size === SK && S.sides === "each") {
        q.set("sides", "2");
        if (S.mattress2) q.set("mattress2", S.mattress2); else q.delete("mattress2");
        if (S.firmness2) q.set("firmness2", S.firmness2); else q.delete("firmness2");
      } else { q.delete("sides"); q.delete("mattress2"); q.delete("firmness2"); }
      history.replaceState(history.state, "", location.pathname + "?" + q.toString() + location.hash);
      const keep = new URLSearchParams();
      ["size", "mattress", "base", "firmness", "sides", "mattress2", "firmness2"].forEach((k) => { if (q.get(k)) keep.set(k, q.get(k)); });
      try { sessionStorage.setItem("mb_build", keep.toString()); } catch (e) {}
    } catch (e) {}
  }

  /* Sizes whose base has no stock but keeps selling, from the section (handle -> size -> dispatch date text). */
  const BO = window.MB_BACKORDER || {};
  function backorder(b, size) {
    const h = b && BO[b.handle];
    return h && Object.prototype.hasOwnProperty.call(h, size) ? { eta: h[size] || "" } : null;
  }
  function boText(b, size) {
    const x = backorder(b, size);
    return x ? `The ${b.name} in ${size} is on back order${x.eta ? ", dispatch expected from " + x.eta : ""}.` : "";
  }

  const mattress = () => B.mattresses.find((m) => m.handle === S.mattress);
  const base = () => B.bases.find((b) => b.handle === S.base);
  if (!sellableBase(base())) {
    const ok = B.bases.find((b) => sellableBase(b));
    if (ok) S.base = ok.handle;
  }

  /* The chosen variant, resolving firmness where the model has one. */
  function option() {
    const m = mattress();
    const sz = m && m.bySize[S.size];
    if (!sz) return null;
    const opts = sz.options.filter((o) => o.avail);
    if (!opts.length) return null;
    if (opts.length === 1 && !opts[0].label) return opts[0];
    return opts.find((o) => o.label === S.firmness) || opts[0];
  }

  /* The entry Boutique with any CrafterMotion base IS the Motion Crafter Sleep
     Kit, and the kit page is the price of record (LP 2026-09-23 after a customer
     found the two pages apart). So that pairing prices at the kit variant and
     goes to the cart as the kit, not as two lines. Every other mattress keeps
     the flat range discount. */
  function kitFor(m, b, size) {
    if (!m || !b || !B.kits || m.handle !== (B.kitMattress || "boutique-mattress-memory-foam")) return null;
    const k = B.kits[b.handle] && B.kits[b.handle][size];
    return k && k.avail !== false ? k : null;
  }

  /* A base the store cannot sell in this size shows as sold out (LP 2026-09-28: the 2.0 and 3.0
     Queens were out until mid November and every pairing but the Sleep Kit failed at Add to cart).
     The kit is its own product, so while its variant is on sale the Boutique pairing stays open
     even when the base on its own is not. */
  function baseSellable(b, size, m) {
    const bs = b && b.bySize[size];
    if (!bs) return false;
    return bs.avail !== false || !!kitFor(m, b, size);
  }

  function priced() {
    const m = mattress(), b = base();
    const sz = m && m.bySize[S.size];
    const bs = b && b.bySize[S.size];
    const opt = option();
    if (!sz || !bs || !opt) return null;
    const qty = sz.qty || 1;
    const mattressTotal = opt.price * qty;
    const sub = mattressTotal + bs.price;
    const kit = kitFor(m, b, S.size);
    if (kit) {
      const total = kit.price;
      const off = sub - total;
      return { m, b, opt, qty, kit, off, baseOff: 0, totalOff: off, mattressTotal, baseTotal: bs.price, sub, total, rrp: sub };
    }
    if (bs.avail === false) return null;
    const off = B.off[m.range] || 0;              // flat, never doubled on Split King
    const baseOff = b.off || 0;                   // LP 2026-08-11, 0 / 200 / 400
    const total = sub - off - baseOff;
    return { m, b, opt, qty, off, baseOff, totalOff: off + baseOff, mattressTotal, baseTotal: bs.price, sub, total, rrp: sub };
  }

  /* ---------- each side of a Split King ---------------------------------
     A Split King is two Long Singles, so a couple can choose a different
     mattress for each side (LP 2026-09-29, after a customer bought a Sleep Kit
     plus two more mattresses to get one). */
  function each() { return S.size === SK && S.sides === "each"; }
  function picked(h) { return h === S.mattress || (each() && h === S.mattress2); }
  function mattressBy(h) { return B.mattresses.find((m) => m.handle === h); }

  /* One side's variant: its mattress in Long Single (the Split King entry lists
     the Long Single variants) at that side's firmness. */
  function sideOption(h, firm) {
    const m = mattressBy(h);
    const sz = m && m.bySize[SK];
    if (!sz) return null;
    const opts = sz.options.filter((o) => o.avail);
    if (!opts.length) return null;
    if (opts.length === 1 && !opts[0].label) return opts[0];
    return opts.find((o) => o.label === firm) || opts[0];
  }

  /* Priced by the rules LP approved on 2026-09-29.
     1. The same variant on both sides is "Same on both sides" exactly, kit included.
     2. Otherwise the parts, less the bigger range saving once (the two automatic
        savings never combine at checkout) and the base saving.
     3. The kit's Boutique on one side and mattress X on the other costs halfway
        between the kit and a pair of X. Where that is under the parts it sells as
        the kit plus an upgrade line, and with no upgrade priced for it the team
        prices it by hand. */
  function pricedSides(b) {
    b = b || base();
    const bs = b && b.bySize[SK];
    const m1 = mattressBy(S.mattress), m2 = mattressBy(S.mattress2);
    const a = sideOption(S.mattress, S.firmness), c = sideOption(S.mattress2, S.firmness2);
    if (!bs || !m1 || !m2 || !a || !c) return null;
    const q = { b, bs, m1, a, m2, c };
    if (a.id === c.id) {
      const qty = m1.bySize[SK].qty || 1;
      const sub = a.price * qty + bs.price;
      const kit = kitFor(m1, b, SK);
      if (kit) {
        return Object.assign(q, { how: "kit", kit, qty, baseOff: 0, totalOff: sub - kit.price, baseTotal: bs.price, total: kit.price, rrp: sub });
      }
      if (bs.avail === false) return null;
      const off = B.off[m1.range] || 0, baseOff = b.off || 0;
      return Object.assign(q, { how: "same", qty, baseOff, totalOff: off + baseOff, baseTotal: bs.price, total: sub - off - baseOff, rrp: sub });
    }
    const baseOff = b.off || 0;
    const sub = a.price + c.price + bs.price;
    const parts = sub - Math.max(B.off[m1.range] || 0, B.off[m2.range] || 0) - baseOff;
    const rrp = sub;
    const kitM = B.kitMattress || "boutique-mattress-memory-foam";
    if ((m1.handle === kitM) !== (m2.handle === kitM)) {
      const kit = kitFor(m1.handle === kitM ? m1 : m2, b, SK);
      const xm = m1.handle === kitM ? m2 : m1, xo = m1.handle === kitM ? c : a;
      const pairX = bs.price + 2 * xo.price - (B.off[xm.range] || 0) - baseOff;
      const halfway = kit ? (kit.price + pairX) / 2 : parts;
      if (kit && halfway < parts) {
        const byBase = B.sideUpgrade && B.sideUpgrade.byBase && B.sideUpgrade.byBase[b.handle];
        const up = byBase && byBase[xm.handle];
        /* an upgrade priced off another kit price is stale, so the team prices it instead */
        if (up && up.id && Math.abs(Number(up.price) - (halfway - kit.price)) <= 1) {
          const total = kit.price + Number(up.price);
          return Object.assign(q, { how: "kitup", kit, up, xm, xo, baseOff: 0, totalOff: sub - total, baseTotal: bs.price, total, rrp });
        }
        /* bundle-ux 2026-10-16: the shopper can still buy this mix now as the pieces with the bundle saving,
           and ask the team for its hand set price beside it. Only a base that cannot be sold on its own
           leaves the ask alone. */
        if (bs.avail === false) return Object.assign(q, { how: "ask", kit, xm, xo, baseOff: 0, baseTotal: bs.price, rrp });
        return Object.assign(q, { how: "parts", askToo: true, baseOff, totalOff: sub - parts, baseTotal: bs.price, total: parts, rrp });
      }
    }
    if (bs.avail === false) return null;
    return Object.assign(q, { how: "parts", baseOff, totalOff: sub - parts, baseTotal: bs.price, total: parts, rrp });
  }

  function sellableBase(b) { return each() ? !!pricedSides(b) : baseSellable(b, S.size, mattress()); }

  /* ---------- render ---------------------------------------------------- */
  function sizeRow() {
    return B.sizes.map((s) =>
      `<button type="button" class="mb-chip${s === S.size ? " sel" : ""}" data-size="${esc(s)}">
         ${esc(s)}${s === "Split King" ? "<small>two mattresses</small>" : ""}
       </button>`).join("");
  }

  function mattressCards() {
    /* Grouped by range, because the saving is different per range and a shopper
       scrolling past the last Boutique into the first Therapedic had no signal
       that the price ladder had started again. The card itself is the same shape
       as the Boutique and Therapedic collection pages so the ranges look like
       themselves here. */
    const GROUPS = [
      { range: "boutique", title: "The Boutique range" },
      { range: "therapedic", title: "The Australian made Therapedic range" },
    ];
    return GROUPS.map((g) => {
      let items = B.mattresses.filter((m) => m.range === g.range);
      if (!items.length) return "";
      const ranked = items.map((m, i) => ({ m, i, r: feelRank(m.feel) }));
      const ordered = ranked.every((x) => x.r != null);
      if (ordered) items = ranked.sort((x, y) => x.r - y.r || x.i - y.i).map((x) => x.m);
      const off = B.off[g.range] || 0;
      return `
      <section class="mb-range" data-range="${esc(g.range)}">
        <header class="mb-range__h">
          <h3 class="mb-range__t">${esc(g.title)}</h3>
          <p class="mb-range__s">Take any one of these with a CrafterMotion base and ${money(off)} comes off at checkout, once per bed.${g.range === "boutique" && B.kits ? " Choose the Boutique and the pair is priced as the Motion Crafter Sleep Kit, the same price as on the kit page." : ""}</p>
        </header>
        ${ordered ? `<p class="mb-feelscale"><span>Softer</span><i aria-hidden="true"></i><span>Firmer</span></p>` : ""}
        <div class="mb-grid">${items.map(card).join("")}</div>
      </section>`;
    }).join("");
  }

  /* Feel words on the cards, softest to firmest. A mattress sold in several feels has no single place. */
  function feelRank(f) {
    f = String(f || "").toLowerCase();
    if (/options|combinations|,| or /.test(f)) return null;
    if (/extra firm/.test(f)) return 5;
    if (/medium firm/.test(f)) return 3;
    if (/medium plush|medium soft/.test(f)) return 2;
    if (/plush|soft/.test(f)) return 1;
    if (/firm/.test(f)) return 4;
    if (/medium/.test(f)) return 2.5;
    return null;
  }

  function cardSrc(m) {
    if (!m.card) return "";
    if (B.assetDir && /\/t\/\d+\/assets\//.test(m.card)) return B.assetDir + m.card.split("/").pop().split("?")[0];
    return m.card;
  }

  function cardFoot(m) {
    if (each()) return cardFootSides(m);
    const sz = m.bySize[S.size];
    const avail = !!sz && sz.options.some((o) => o.avail);
    const off = B.off[m.range] || 0;
    const rawFrom = avail ? Math.min(...sz.options.filter((o) => o.avail).map((o) => o.price)) * (sz.qty || 1) : null;
    const alt = avail ? null : (firstAvailableSize(m) || null);
    if (!avail) return `<span class="mb-card__na">Not made in ${esc(S.size)}${alt ? `, available in ${esc(alt)}` : ""}</span>`;
    const b = base();
    const bs = b && b.bySize[S.size];
    const kit = bs ? kitFor(m, b, S.size) : null;
    const two = (sz.qty || 1) > 1;
    if (kit) {
      return `<span class="mb-card__price">${money(rawFrom)}<small>${two ? "two Long Singles" : esc(S.size)}. With the ${esc(b.name)} it makes the Sleep Kit, ${money(kit.price)} for the base and ${two ? "both mattresses" : "mattress"}</small></span>
              <span class="mb-card__off">Sleep Kit</span>`;
    }
    return `<span class="mb-card__price">${money(rawFrom - off)}<small>${two ? "two Long Singles" : esc(S.size)} with a CrafterMotion base, usually ${money(rawFrom)}</small></span>
            <span class="mb-card__off">${money(off)} off</span>`;
  }

  /* With a side each, a card is one Long Single. The range saving comes off once
     per bed rather than per side, so it shows in the bar, and the pill names the
     side the card is on. */
  function cardFootSides(m) {
    const sz = m.bySize[SK];
    const opts = sz ? sz.options.filter((o) => o.avail) : [];
    if (!opts.length) {
      const alt = firstAvailableSize(m) || null;
      return `<span class="mb-card__na">Not made in ${esc(S.size)}${alt ? `, available in ${esc(alt)}` : ""}</span>`;
    }
    const lo = opts.reduce((x, o) => (o.price < x.price ? o : x));
    const side = m.handle === S.mattress && m.handle === S.mattress2 ? "Both sides"
      : m.handle === S.mattress ? "Left side" : m.handle === S.mattress2 ? "Right side" : "";
    return `<span class="mb-card__price">${money(lo.price)}<small>one side${lo.compareAt > lo.price ? ", was " + money(lo.compareAt) : ""}</small></span>
            ${side ? `<span class="mb-card__off mb-card__side">${side}</span>` : ""}`;
  }

  function card(m) {
    const sz = m.bySize[S.size];
    const avail = !!sz && sz.options.some((o) => o.avail);
    return `
    <div class="mb-cardwrap">
    <button type="button" class="mb-card mb-card--m${picked(m.handle) ? " sel" : ""}${avail ? "" : " off"}"
            data-mattress="${esc(m.handle)}" ${avail ? "" : "disabled"} aria-pressed="${picked(m.handle)}">
      <span class="mb-pic">
        <img src="${esc(cardSrc(m))}" alt="${esc(m.name)}" loading="lazy" decoding="async">
        ${m.tag ? `<span class="mb-pic__tag">${esc(m.tag)}</span>` : ""}
      </span>
      <span class="mb-card__b">
        <span class="mb-card__top">
          <span class="mb-card__name">${esc(m.name)}</span>
          <span class="mb-card__feel">${esc(m.feel)}</span>
        </span>
        <span class="mb-card__blurb">${esc(m.blurb)}</span>
        <span class="mb-layers">
          ${(m.layers || []).map((l) => `<span><b>${esc(l.n)}</b><i>${esc(l.d)}</i></span>`).join("")}
        </span>
        <span class="mb-card__foot">
          ${cardFoot(m)}
        </span>
      </span>
    </button>
    <a class="mb-more" href="${esc(m.url)}"
       aria-label="Find out more about the ${esc(m.name)}">Find out more<i aria-hidden="true"></i></a>
    </div>`;
  }

  function firmnessStep() {
    const wrap = $("#mbFirmStep");
    if (!wrap) return;
    if (each()) { firmnessSides(wrap); stepNumbers(); return; }
    const m = mattress();
    const sz = m && m.bySize[S.size];
    const opts = sz ? sz.options.filter((o) => o.avail && o.label) : [];
    if (!opts.length) { wrap.hidden = true; wrap.innerHTML = ""; stepNumbers(); return; }
    if (!opts.some((o) => o.label === S.firmness)) S.firmness = opts[0].label;
    wrap.hidden = false;
    stepNumbers();
    wrap.innerHTML = `
      <div class="mb-step__h"><span class="mb-step__n">3</span><h2 class="mb-step__t">Choose your firmness</h2></div>
      <p class="mb-step__s">The ${esc(m.name)} is built in ${opts.length} firmnesses off the same construction, so this is the feel rather than the quality. If you are unsure, the middle option suits most people and the 120 night trial covers the rest.</p>
      <div class="mb-chips">
        ${opts.map((o) => `<button type="button" class="mb-chip${o.label === S.firmness ? " sel" : ""}" data-firm="${esc(o.label)}">${esc(o.label)}</button>`).join("")}
      </div>`;
  }

  function stepNumbers() {
    const n = $("#mbBaseN"), f = $("#mbFirmStep");
    if (n && f) n.textContent = f.hidden ? "3" : "4";
  }

  /* Each side keeps its own firmness, and both sides show here rather than only
     the active one: the grid moves on to side two as soon as side one is picked,
     so side one would otherwise keep its first firmness without the choice ever
     being on screen. */
  function firmnessSides(wrap) {
    const rows = [[1, S.mattress, "firmness"], [2, S.mattress2, "firmness2"]].map(([n, h, key]) => {
      const m = mattressBy(h);
      const sz = m && m.bySize[SK];
      const opts = sz ? sz.options.filter((o) => o.avail && o.label) : [];
      if (!opts.length) return null;
      if (!opts.some((o) => o.label === S[key])) S[key] = opts[0].label;
      return { n, m, opts, cur: S[key] };
    }).filter(Boolean);
    if (!rows.length) { wrap.hidden = true; wrap.innerHTML = ""; return; }
    wrap.hidden = false;
    wrap.innerHTML = rows.map((r, i) => `
      <div class="mb-step__h${i ? " mb-step__h--sub" : ""}">${i ? "" : `<span class="mb-step__n">3</span>`}<h2 class="mb-step__t">${r.n === 1 ? "Left" : "Right"} side firmness</h2></div>
      <p class="mb-step__s">${i ? `The ${esc(r.m.name)} is built in ${r.opts.length} firmnesses off the same construction.`
        : `The ${esc(r.m.name)} is built in ${r.opts.length} firmnesses off the same construction, so this is the feel rather than the quality. If you are unsure, the middle option suits most people and the 120 night trial covers the rest.`}</p>
      <div class="mb-chips">
        ${r.opts.map((o) => `<button type="button" class="mb-chip${o.label === r.cur ? " sel" : ""}" data-firm="${esc(o.label)}" data-firmside="${r.n}">${esc(o.label)}</button>`).join("")}
      </div>`).join("");
  }

  function baseCards() {
    const m = mattress();
    return B.bases.map((b) => {
      const bs = b.bySize[S.size];
      const avail = !!bs && (each() ? !!pricedSides(b) : baseSellable(b, S.size, m));
      return `
      <button type="button" class="mb-card mb-card--b${b.handle === S.base ? " sel" : ""}${avail ? "" : " off"}"
              data-base="${esc(b.handle)}" ${avail ? "" : "disabled"} aria-pressed="${b.handle === S.base}">
        <span class="mb-base__img"><img src="${esc(b.img)}" alt="${esc(b.name)}" loading="lazy" decoding="async"></span>
        <span class="mb-card__b">
          <span class="mb-card__top">
            <span class="mb-card__name">${esc(b.name)}</span>
            <span class="mb-card__feel">${esc(b.tag)}</span>
          </span>
          <span class="mb-feats">${(b.features || []).map((f) => `<span>${esc(f)}</span>`).join("")}</span>
          <span class="mb-card__foot">
            ${avail ? `<span class="mb-card__price">${money(bs.price - (b.off || 0))}<small>base in ${esc(S.size)}${b.off ? ", usually " + money(bs.price) : ""}</small></span>${b.off ? `<span class="mb-card__off">${money(b.off)} off</span>` : ""}`
                    : `<span class="mb-card__na">${bs ? "Sold out" : "Not available"} in ${esc(S.size)}</span>`}
          </span>
          ${avail && backorder(b, S.size) ? `<span class="mb-card__bo">On back order in ${esc(S.size)}${backorder(b, S.size).eta ? ", dispatch expected from " + esc(backorder(b, S.size).eta) : ""}. You pay when you order and we send it when the new stock arrives.</span>` : ""}
        </span>
      </button>`;
    }).join("");
  }

  /* The Split King controls sit straight above the grid they steer, and only
     exist while the size is Split King. */
  function sidesControl() {
    let host = $("#mbSides");
    if (!host) {
      const grid = $("#mbMattresses");
      if (!grid) return;
      host = document.createElement("div");
      host.id = "mbSides";
      host.className = "mb-sides";
      grid.parentNode.insertBefore(host, grid);
    }
    if (S.size !== SK) { host.hidden = true; host.innerHTML = ""; return; }
    const on = each();
    const name = (h) => { const m = mattressBy(h); return m ? m.name : ""; };
    host.hidden = false;
    host.innerHTML = `
      <div class="mb-chips" role="group" aria-label="Mattresses on the Split King">
        <button type="button" class="mb-chip${on ? "" : " sel"}" data-sides="same" aria-pressed="${!on}">Same on both sides</button>
        <button type="button" class="mb-chip${on ? " sel" : ""}" data-sides="each" aria-pressed="${on}">Different each side</button>
      </div>
      <p class="mb-sides__help">A Split King is two Long Single mattresses side by side, so each of you can choose your own.${on ? " Left and right are as you lie in bed." : ""}</p>
      ${on ? `<div class="mb-chips mb-sides__pick" role="group" aria-label="Side you are choosing for">
        <button type="button" class="mb-chip${S.active === 1 ? " sel" : ""}" data-side="1" aria-pressed="${S.active === 1}">Left side<small>${esc(name(S.mattress))}</small></button>
        <button type="button" class="mb-chip${S.active === 2 ? " sel" : ""}" data-side="2" aria-pressed="${S.active === 2}">Right side<small>${esc(name(S.mattress2))}</small></button>
      </div>
      <p class="mb-sides__next" role="status">${nextSide()}</p>` : ""}`;
  }

  /* What the shopper does next on a Split King with a side each, said in the controls and in the bar. */
  function nextSide() {
    if (!each()) return "";
    if (S.active === 1 && !S.leftChosen) return "Tap a mattress below for the left side.";
    if (S.active === 2 && !S.rightChosen) return "Left side chosen. Now choose the right side.";
    /* "Boutique" is said once in the range heading, so the confirmation keeps to the model name */
    const short = (m) => (m ? (m.name === "Boutique" ? m.name : m.name.replace(/^Boutique /, "")) : "");
    const firm = (h, f) => { const o = sideOption(h, f); return o && o.label ? ", " + o.label : ""; };
    return "Left side: " + short(mattressBy(S.mattress)) + firm(S.mattress, S.firmness) + ". Right side: " + short(mattressBy(S.mattress2)) + firm(S.mattress2, S.firmness2) + ".";
  }

  function refreshCards() {
    $$(".mb-card--m").forEach((c) => { const on = picked(c.dataset.mattress); c.classList.toggle("sel", on); c.setAttribute("aria-pressed", on); });
    B.mattresses.forEach((m) => { const f = $('[data-mattress="' + m.handle + '"] .mb-card__foot'); if (f) f.innerHTML = cardFoot(m); });
  }

  function repaintSides() {
    sidesControl();
    refreshCards();
    $("#mbBases").innerHTML = baseCards();
    firmnessStep();
    summary();
  }

  /* The active pill decides which side a card sets. The first pick for side one
     moves on to side two, so a couple can go straight down the grid. */
  function setSide(h) {
    if (S.active === 2) { S.mattress2 = h; S.firmness2 = null; S.autoSwitch = false; S.rightChosen = true; return; }
    S.mattress = h;
    S.firmness = null;
    S.leftChosen = true;
    if (S.autoSwitch) { S.autoSwitch = false; S.active = 2; }
  }

  function setSides(v) {
    if (S.size !== SK || v === S.sides) return;
    S.sides = v === "each" ? "each" : "same";
    /* side two starts as the mattress already chosen, so the bar stays priced */
    if (S.sides === "each") { S.mattress2 = S.mattress; S.firmness2 = S.firmness; S.active = 1; S.autoSwitch = true; S.leftChosen = false; S.rightChosen = false; }
    repaintSides();
    const back = $('#mbSides [data-sides="' + S.sides + '"]');
    if (back) back.focus();
  }

  /* Shopify Inbox's launcher is a button (part "activator") inside the full screen shopify-chat element. Lift it
     by however much of the fixed bar is on screen, so it never covers the bar's buttons or prices. */
  /* The launcher's own gap to the bottom of the screen is measured once with no lift, and again after a resize. */
  let chatGap = null;
  function liftChat() {
    const bar = $("#mbBar"), chat = document.querySelector("shopify-chat");
    const btn = chat && chat.shadowRoot && chat.shadowRoot.querySelector('[part~="activator"]');
    if (!bar || !btn) return;
    const root = document.documentElement;
    const cur = parseFloat(root.style.getPropertyValue("--mb-chat-lift")) || 0;
    if (chatGap == null) {
      if (cur) { root.style.setProperty("--mb-chat-lift", "0px"); return; }
      const b = btn.getBoundingClientRect();
      if (!b.height) return;
      chatGap = innerHeight - b.bottom;
    }
    const r = bar.getBoundingClientRect();
    const onScreen = r.top < innerHeight && r.bottom > 0 ? innerHeight - Math.max(r.top, 0) : 0;
    const lift = Math.min(Math.max(0, Math.round(onScreen + 10 - chatGap)), Math.max(0, innerHeight - 80));
    if (lift !== cur) root.style.setProperty("--mb-chat-lift", lift + "px");
  }
  let liftQueued = false;
  const queueLift = () => { if (liftQueued) return; liftQueued = true; requestAnimationFrame(() => { liftQueued = false; liftChat(); }); };
  addEventListener("scroll", queueLift, { passive: true });
  addEventListener("resize", () => { chatGap = null; queueLift(); });
  /* the launcher arrives after the page, so look for it for a little while */
  let liftTries = 0;
  const liftTimer = setInterval(() => { liftChat(); if (++liftTries > 40) clearInterval(liftTimer); }, 500);

  /* A CrafterMotion base or Sleep Kit already in the cart, named with its size. */
  function bedInCart() {
    const sizeOf = {};
    B.bases.forEach((b) => Object.keys(b.bySize).forEach((sz) => { sizeOf[String(b.bySize[sz].id)] = sz; }));
    Object.keys(B.kits || {}).forEach((h) => Object.keys(B.kits[h]).forEach((sz) => { sizeOf[String(B.kits[h][sz].id)] = sz; }));
    fetch("/cart.js", { headers: { Accept: "application/json" } }).then((r) => r.json()).then((cart) => {
      const line = (cart.items || []).find((l) => sizeOf[String(l.variant_id)]);
      let host = $("#mbInCart");
      if (!line) { if (host) host.hidden = true; return; }
      if (!host) {
        const wrap = $(".mb__wrap");
        if (!wrap) return;
        host = document.createElement("p");
        host.id = "mbInCart";
        host.className = "mb-incart";
        host.setAttribute("role", "status");
        wrap.insertBefore(host, wrap.firstChild);
      }
      host.hidden = false;
      host.innerHTML = `Your ${esc(sizeOf[String(line.variant_id)])} bed is in your cart. <a href="${esc((B.origin || "") + "/cart")}">View cart</a>`;
    }).catch(() => {});
  }
  bedInCart();
  addEventListener("pageshow", (e) => { if (e.persisted) bedInCart(); });

  /* Plain text of the bed on screen, for the request form. */
  function configText() {
    const b = base();
    const nm = (m, o) => (m ? m.name + (o && o.label ? ", " + o.label : "") : "not chosen");
    const head = (b ? b.name + ", " : "") + S.size + ".";
    if (each()) return `${head} Left side: ${nm(mattressBy(S.mattress), sideOption(S.mattress, S.firmness))}. Right side: ${nm(mattressBy(S.mattress2), sideOption(S.mattress2, S.firmness2))}.`;
    return `${head} ${S.size === SK ? "Both sides" : "Mattress"}: ${nm(mattress(), option())}.`;
  }

  function syncQuote() {
    const t = configText();
    $$("#mbRoot [data-mc-quote]").forEach((el) => el.setAttribute("data-mc-quote-summary", t));
  }

  function askUs() {
    const summary = configText();
    if (window.mcBundleQuote && typeof window.mcBundleQuote.open === "function") {
      window.mcBundleQuote.open({ source: "Build Your Bundle", summary: summary });
      return;
    }
    /* without the request form on the page a button that does nothing reads as broken */
    window.location.href = (B.origin || "") + "/pages/contact-us";
  }

  /* The money block, shared by both bars. Usually is the lines added up, the saving is usually minus the price. */
  function money3(off, total, usual, kit, two) {
    return `
        <div class="mb-bar__money">
          ${off > 0 ? `<span class="mb-bar__off">${kit ? "Sleep Kit saving" : "Bundle saving"} ${money(off)}</span>` : ""}
          <span class="mb-bar__tot">${money(total)}</span>
          ${off > 0 ? `<span class="mb-bar__rrp">Usually ${money(usual)}</span>` : ""}
          ${kit ? `<span class="mb-bar__kit">Sleep Kit price, base and ${two ? "two Boutique mattresses" : "Boutique mattress"}</span>` : ""}
        </div>`;
  }
  function ctas() {
    return `
        <div class="mb-bar__cta">
          <button type="button" class="mb-btn mb-btn--ghost" id="mbAdd">Add to cart</button>
          <button type="button" class="mb-btn" id="mbBuy">Go to checkout</button>
        </div>`;
  }
  /* Shopify keeps whichever is bigger, the automatic bundle saving or WELCOME5 on the cart subtotal, so a
     first order can come in under the bar's total. Said only when that is true for the bed on screen. */
  function welcomeNote(how, sub, off) {
    if ((how !== "same" && how !== "parts") || !(Number(sub) * 0.05 > Number(off))) return "";
    return `<p class="mb-bar__note">At checkout you get the bigger of the bundle saving or the 5 percent welcome discount on a first order, so your total can come in a little lower.</p>`;
  }

  function boNote(b, size) {
    const t = boText(b, size);
    return t ? `<p class="mb-bar__bo">${esc(t)}</p>` : "";
  }

  /* A Split King with two different mattresses is no longer the Sleep Kit, so say why its price changed. */
  function whyMix(q) {
    if (!q || q.how === "kit" || q.how === "same" || !q.a || !q.c || q.a.id === q.c.id) return "";
    const kitM = B.kitMattress || "boutique-mattress-memory-foam";
    if (!(B.kits && B.kits[q.b.handle] && B.kits[q.b.handle][SK])) return "";
    const oneKit = (q.m1.handle === kitM) !== (q.m2.handle === kitM);
    return `<p class="mb-bar__why">The Sleep Kit price is for the Boutique on both sides. ${oneKit ? "With a different mattress on one side" : "With other mattresses"}, each piece is priced on its own with the bundle saving.</p>`;
  }

  /* Small print that used to sit in the fixed bar, now in the page under the base cards. */
  function notes(html) {
    const n = $("#mbNotes");
    if (!n) return;
    n.innerHTML = html + `<p class="mb-notes__seniors">Seniors Card holder? Add your card in the cart and 10 percent comes off the base or Sleep Kit, in place of the other savings.</p>`;
    const a = $("#mbNotesAsk");
    if (a) a.addEventListener("click", askUs);
  }

  function summarySides(bar) {
    const q = pricedSides();
    if (!q) {
      const sb = base();
      const soldOut = sb && sb.bySize[SK] && !sellableBase(sb);
      bar.innerHTML = soldOut
        ? `<div class="mb-bar__in"><p class="mb-bar__na">The ${esc(sb.name)} is sold out in ${esc(S.size)} right now. Pick another base or another size.</p></div>`
        : `<div class="mb-bar__in"><p class="mb-bar__na">That combination is not available in ${esc(S.size)}. Pick another size or another mattress.</p></div>`;
      return;
    }
    const ask = q.how === "ask";
    const nm = (m, o) => esc(m.name) + (o.label ? ", " + esc(o.label) : "");
    /* the ask state names the bed without prices, because the team sets its price */
    const line = (b, label, price) => `<span class="mb-bar__l"><b>${b}</b><i>${label}${ask ? "" : " &nbsp;" + money(price)}</i></span>`;
    const next = nextSide();
    const lines = `
        ${next ? `<p class="mb-bar__next" role="status">${esc(next)}</p>` : ""}
        ${whyMix(q)}
        <div class="mb-bar__lines mb-bar__lines--sides">
          ${line(nm(q.m1, q.a), "Left side", q.a.price)}
          <span class="mb-bar__plus" aria-hidden="true">+</span>
          ${line(nm(q.m2, q.c), "Right side", q.c.price)}
          <span class="mb-bar__plus" aria-hidden="true">+</span>
          ${line(esc(q.b.name), esc(S.size), q.bs.price)}
        </div>`;
    if (ask) {
      bar.innerHTML = `
      <div class="mb-bar__in">${lines}
        <p class="mb-bar__ask">Our team prices this mix. Send it through and we will email you the price.</p>
        <div class="mb-bar__cta">
          <button type="button" class="mb-btn" id="mbAsk">Ask us for this price</button>
        </div>
      </div>`;
      $("#mbAsk").addEventListener("click", askUs);
      notes(boNote(q.b, S.size));
      liftChat();
      return;
    }
    const two = q.how === "kit" && (q.qty || 1) > 1;
    bar.innerHTML = `
      <div class="mb-bar__in">${lines}
        ${money3(q.rrp - q.total, q.total, q.rrp, q.how === "kit", two)}
        ${ctas()}
      </div>`;
    $("#mbAdd").addEventListener("click", addToCart);
    $("#mbBuy").addEventListener("click", checkout);
    notes(welcomeNote(q.how, q.rrp, q.totalOff)
      + (q.askToo ? `<p class="mb-bar__ask">Or <button type="button" class="mb-bar__asklink" id="mbNotesAsk">ask us to price this mix</button>. Our team can price a mix by email.</p>` : "")
      + boNote(q.b, S.size));
    liftChat();
  }

  function summary() {
    const bar = $("#mbBar");
    if (!bar) return;
    syncQuote();
    saveUrl();
    if (each()) return summarySides(bar);
    const p = priced();
    if (!p) {
      const sb = base();
      const soldOut = sb && sb.bySize[S.size] && !baseSellable(sb, S.size, mattress());
      bar.innerHTML = soldOut
        ? `<div class="mb-bar__in"><p class="mb-bar__na">The ${esc(sb.name)} is sold out in ${esc(S.size)} right now. Pick another base or another size.</p></div>`
        : `<div class="mb-bar__in"><p class="mb-bar__na">That combination is not available in ${esc(S.size)}. Pick another size or another mattress.</p></div>`;
      return;
    }
    bar.innerHTML = `
      <div class="mb-bar__in">
        <div class="mb-bar__lines">
          <span class="mb-bar__l"><b>${esc(p.m.name)}${p.opt.label ? ", " + esc(p.opt.label) : ""}</b><i>${p.qty > 1 ? "two Long Singles" : esc(S.size)} &nbsp;${money(p.mattressTotal)}</i></span>
          <span class="mb-bar__plus" aria-hidden="true">+</span>
          <span class="mb-bar__l"><b>${esc(p.b.name)}</b><i>${esc(S.size)} &nbsp;${money(p.baseTotal)}</i></span>
        </div>
        ${money3(p.rrp - p.total, p.total, p.rrp, !!p.kit, p.qty > 1)}
        ${ctas()}
      </div>`;
    $("#mbAdd").addEventListener("click", addToCart);
    $("#mbBuy").addEventListener("click", checkout);
    notes(welcomeNote(p.kit ? "kit" : "same", p.sub, p.totalOff) + boNote(p.b, S.size));
    liftChat();
  }

  function paint(what) {
    if (!what) $("#mbSizes").innerHTML = sizeRow();
    if (!what || what === "size") {
      $$("[data-size]").forEach((c) => c.classList.toggle("sel", c.dataset.size === S.size));
      $("#mbMattresses").innerHTML = mattressCards();
      $("#mbBases").innerHTML = baseCards();
      /* a size change can strand the selection on a model that is not made in it */
      const m = mattress();
      if (!m || !m.bySize[S.size]) {
        const next = B.mattresses.find((x) => x.bySize[S.size]);
        if (next) { S.mattress = next.handle; $$(".mb-card--m").forEach((c) => c.classList.toggle("sel", c.dataset.mattress === S.mattress)); $("#mbBases").innerHTML = baseCards(); }
      }
      if (each()) refreshCards();
      sidesControl();
    }
    firmnessStep();
    summary();
  }

  /* ---------- quiz ------------------------------------------------------
     The Mattress Match quiz opens in a modal over the builder rather than
     taking the visitor away, so the bundle they were building is never lost.
     The quiz posts its winner back and the card selects itself. A visitor who
     opens it in a new tab instead comes back through the url preselect above. */
  const QUIZ_ORIGIN = "https://mc-mattress-match.netlify.app";

  function openQuiz() {
    if ($("#mbQuiz")) { $("#mbQuiz").hidden = false; return; }
    const wrap = document.createElement("div");
    wrap.id = "mbQuiz";
    wrap.className = "mb-quiz";
    wrap.innerHTML =
      '<div class="mb-quiz__back" data-quizclose></div>' +
      '<div class="mb-quiz__panel" role="dialog" aria-modal="true" aria-label="Mattress Match quiz">' +
        '<button type="button" class="mb-quiz__x" data-quizclose aria-label="Close the quiz">Close</button>' +
        '<iframe class="mb-quiz__frame" title="Mattress Match quiz" scrolling="no" ' +
          'src="' + QUIZ_ORIGIN + '/?embed=1&bundle=1"></iframe>' +
      '</div>';
    document.body.appendChild(wrap);
    document.body.style.overflow = "hidden";
  }

  function quizUnavailable(name) {
    closeQuiz();
    const host = $("#mbMattresses");
    if (!host) return;
    let n = $("#mbQuizMiss");
    if (!n) {
      n = document.createElement("p");
      n.id = "mbQuizMiss";
      n.className = "mb-quizmiss";
      n.setAttribute("role", "status");
      host.parentNode.insertBefore(n, host);
    }
    n.textContent = name + " is out of stock right now, so it is not in the builder. Pick the closest one below or come back when it is back.";
    n.scrollIntoView({ block: "center", behavior: "smooth" });
  }

  function closeQuiz() {
    const q = $("#mbQuiz");
    if (q) q.remove();
    document.body.style.overflow = "";
  }

  addEventListener("message", (e) => {
    if (e.origin !== QUIZ_ORIGIN) return;
    const d = e.data || {};
    if (d.source !== "mc-mattress-match") return;
    const frame = $(".mb-quiz__frame");
    if (d.type === "height" && d.height && frame) frame.style.height = d.height + "px";
    if (d.type === "useInBundle" && d.handle) {
      const m = B.mattresses.find((x) => x.handle === d.handle);
      if (m && m.bySize[S.size]) {
        /* with a side each, the match goes to the side being chosen */
        if (each()) setSide(m.handle);
        else { S.mattress = m.handle; S.firmness = null; }
        closeQuiz();
        paint("size");
        const btn = $('[data-mattress="' + d.handle + '"]');
        const el = btn && btn.closest(".mb-cardwrap");
        if (el) {
          el.scrollIntoView({ block: "center", behavior: "smooth" });
          el.classList.add("mb-justpicked");
          setTimeout(() => el.classList.remove("mb-justpicked"), 2400);
        }
      } else if (m) {
        /* the match is not made in the size they picked, so move them to a size
           it does come in rather than silently ignoring the result */
        const alt = firstAvailableSize(m);
        if (alt) { S.size = alt; S.mattress = m.handle; S.firmness = null; closeQuiz(); paint("size"); }
        else { quizUnavailable(m.name); }
      } else {
        /* the quiz can recommend something the builder does not offer, and a
           button that does nothing reads as broken */
        quizUnavailable(d.name || "That match");
      }
    }
  });

  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-quizopen]")) { e.preventDefault(); openQuiz(); }
    if (e.target.closest("[data-quizclose]")) { e.preventDefault(); closeQuiz(); }
  });
  addEventListener("keydown", (e) => { if (e.key === "Escape") closeQuiz(); });

  /* ---------- cart ------------------------------------------------------ */
  function lineItems() {
    if (each()) return sideItems();
    const p = priced();
    if (!p) return null;
    const bs = p.b.bySize[S.size];
    /* One code per mattress tier and base tier, because the two discounts add up
       to six possible totals and a Shopify code is one fixed amount. */
    /* No discount code. The bundle saving is an AUTOMATIC Buy X Get Y in
       Shopify, so it applies itself at checkout and only when an adjustable
       base is in the cart. Nothing to type, nothing to leak. */
    if (p.kit) return { kit: p.kit.id, expect: p.totalOff, gross: p.kit.price };
    return { mid: p.opt.id, mqty: p.qty, bid: bs.id, expect: p.totalOff, gross: p.sub };
  }

  /* A side each goes to the cart as the base plus one Long Single per side, or as
     the kit plus its upgrade line. The same variant on both sides is the ordinary
     pair, so it goes in exactly as "Same on both sides" does. */
  function sideItems() {
    const q = pricedSides();
    if (!q || q.how === "ask") return null;
    if (q.how === "kit") return { kit: q.kit.id, expect: q.totalOff, gross: q.kit.price };
    if (q.how === "same") return { mid: q.a.id, mqty: q.qty, bid: q.bs.id, expect: q.totalOff, gross: q.a.price * q.qty + q.bs.price };
    if (q.how === "kitup") {
      /* The swap note sits on the upgrade line, so removing that line in the cart
         leaves a standard kit. A permalink cannot pass line properties, so checkout
         goes through the cart. */
      return { viaCart: true, expect: q.totalOff, items: [
        { id: Number(q.kit.id), quantity: 1 },
        { id: Number(q.up.id), quantity: 1, properties: {
          Mattress: q.xm.name + (q.xo.label ? ", " + q.xo.label : "") + ", Long Single",
          Replaces: "one of the two Boutique Long Singles in the Split King Sleep Kit" } },
      ] };
    }
    const items = [
      { id: Number(q.a.id), quantity: 1, properties: { Side: "Left (as you lie in bed)" } },
      { id: Number(q.c.id), quantity: 1, properties: { Side: "Right (as you lie in bed)" } },
      { id: Number(q.bs.id), quantity: 1 },
    ];
    return { items, viaCart: true, expect: q.totalOff, gross: Number(q.a.price) + Number(q.c.price) + Number(q.bs.price) };
  }

  function cartItems(i) {
    if (i.items) return i.items;
    return i.kit ? [{ id: Number(i.kit), quantity: 1 }] : [{ id: Number(i.mid), quantity: i.mqty }, { id: Number(i.bid), quantity: 1 }];
  }

  /* 2026-10-12: the cart link went to checkout with no WELCOME5 and no spend reward, so Checkout now cost more
     than the same bed through the cart drawer ($4,797.00 against $4,707.15 for a 3.0 Split King and two Boutique
     Deluxe Long Singles). The link now names WELCOME5 and the CART rung the bed earns, $10 per $1,000 up to $50 on
     the full subtotal (a cart link holds only these lines and none of them takes a line discount that combines
     with the codes). The automatic Bundle saving combines with nothing, so Shopify keeps whichever saves more,
     exactly as it does for the drawer. */
  function linkCodes(gross) {
    const tier = Math.max(0, Math.min(5, Math.floor(Math.round(Number(gross) * 100) / 100000)));
    return ["WELCOME5"].concat(tier > 0 ? ["CART" + tier * 10] : []).join(",");
  }

  function checkout() {
    const i = lineItems();
    if (!i) return;
    if (i.viaCart) { checkoutViaCart(i); return; }
    const path = i.path || (i.kit ? `/cart/${i.kit}:1` : `/cart/${i.mid}:${i.mqty},${i.bid}:1`);
    window.location.href = (B.origin || "") + path + (i.gross ? "?discount=" + encodeURIComponent(linkCodes(i.gross)) : "");
  }

  async function checkoutViaCart(i) {
    const btn = $("#mbBuy");
    const was = btn.textContent;
    btn.disabled = true;
    btn.textContent = "Adding...";
    try {
      const r = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: cartItems(i) }),
      });
      if (!r.ok) throw new Error(await r.text());
      /* 2026-10-12 the shared discount sync puts WELCOME5 and the right spend rung on the cart first, as the drawer does */
      const L = window.MCAddonLadder;
      if (L && L.sync) {
        try { await L.sync(await (await fetch("/cart.js", { headers: { Accept: "application/json" } })).json(), { w5: true }); } catch (e) {}
      }
      window.location.href = (B.origin || "") + "/checkout";
    } catch (e) {
      btn.textContent = "Could not add";
      setTimeout(() => { btn.textContent = was; btn.disabled = false; }, 2300);
    }
  }

  async function addToCart() {
    const i = lineItems();
    if (!i) return;
    const btn = $("#mbAdd");
    const was = btn.textContent;
    const old = $("#mbBar .mb-bar__err");
    if (old) old.remove();
    btn.disabled = true;
    btn.textContent = "Adding...";
    try {
      const r = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: cartItems(i) }),
      });
      if (!r.ok) throw new Error(await r.text());
      /* Shopify only applies a code through its own endpoint. Hitting it keeps
         the customer here and puts the discount on the cart. */
      btn.textContent = "Added to cart";
      bedInCart();
      await openSiteCart(btn);
      setTimeout(() => { btn.textContent = was; btn.disabled = false; }, 1900);
    } catch (e) {
      btn.textContent = "Could not add";
      addFailed();
      setTimeout(() => { btn.textContent = was; btn.disabled = false; }, 2300);
    }
  }

  function addFailed() {
    const inner = $("#mbBar .mb-bar__in");
    if (!inner || $("#mbBar .mb-bar__err")) return;
    const p = document.createElement("p");
    p.className = "mb-bar__err";
    p.setAttribute("role", "alert");
    p.textContent = "Sorry, that did not go into your cart. Please press Add to cart again.";
    inner.appendChild(p);
  }

  /* Open whatever cart drawer the theme already uses, rather than shipping a
     second one. Themes differ, so this tries the documented events first, then
     the common custom elements, then a real click on the cart link, and only
     falls back to /cart if none of that exists. */
  async function openSiteCart(from) {
    /* This theme's cart drawer is a custom element with openFrom(trigger) and an
       internal _onVariantAdded listener, so the faithful sequence is to tell it
       the cart changed and then ask it to open. Everything after is a fallback
       for a future theme that works differently. */
    const d = document.querySelector("cart-drawer, #cart-drawer");
    /* The theme's _onVariantAdded reads detail.cart, so the real cart has to
       travel with the event or the drawer opens empty and throws. */
    /* The theme also reads detail.cart.sections[<its own section id>], so the
       rendered drawer markup has to come back with the cart. The id is read off
       the DOM rather than hardcoded, because it is theme instance specific. */
    const drawerSection = d && d.closest("[id^=shopify-section]")
      ? d.closest("[id^=shopify-section]").id.replace("shopify-section-", "") : null;
    let cart = null;
    try {
      /* Only the cart mutation endpoints render sections, GET /cart.js does not,
         so the rendered drawer markup is pulled with a no-op update. */
      const r = await fetch("/cart/update.js", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify(drawerSection ? { attributes: {}, sections: [drawerSection] } : { attributes: {} }),
      });
      cart = await r.json();
    } catch (e) {}
    const fire = (name) => {
      const ev = new CustomEvent(name, { bubbles: true, detail: { cart: cart } });
      try { document.documentElement.dispatchEvent(ev); } catch (e) {}
    };
    if (cart) { fire("variant:added"); fire("cart:change"); fire("cart:refresh"); }

    if (d) {
      if (typeof d.openFrom === "function") {
        try { d.openFrom(from || document.getElementById("mbAdd") || document.body); return true; } catch (e) {}
      }
      if (typeof d.open === "function") { try { d.open(); return true; } catch (e) {} }
      if (typeof d.show === "function") { try { d.show(); return true; } catch (e) {} }
    }

    const trigger = document.querySelector("[aria-controls='cart-drawer'], a[href$='/cart']");
    if (trigger) { trigger.click(); return true; }

    window.location.href = (B.origin || "") + "/cart";
    return false;
  }

  /* ---------- events ---------------------------------------------------- */
  document.addEventListener("click", (e) => {
    const sz = e.target.closest("[data-size]");
    if (sz) { S.size = sz.dataset.size; paint("size"); return; }

    const sd = e.target.closest("#mbSides [data-sides]");
    if (sd) { setSides(sd.dataset.sides); return; }

    const sp = e.target.closest("#mbSides [data-side]");
    if (sp) {
      S.active = sp.dataset.side === "2" ? 2 : 1;
      S.autoSwitch = false;
      repaintSides();
      const pill = $('#mbSides [data-side="' + S.active + '"]');
      if (pill) pill.focus();
      return;
    }

    const mt = e.target.closest("[data-mattress]");
    if (mt && !mt.disabled && each()) { setSide(mt.dataset.mattress); repaintSides(); return; }
    if (mt && !mt.disabled) {
      S.mattress = mt.dataset.mattress;
      S.firmness = null;
      $$(".mb-card--m").forEach((c) => { const on = c.dataset.mattress === S.mattress; c.classList.toggle("sel", on); c.setAttribute("aria-pressed", on); });
      $("#mbBases").innerHTML = baseCards();
      firmnessStep(); summary(); return;
    }

    const fm = e.target.closest("[data-firm]");
    if (fm && each()) {
      const n = fm.dataset.firmside === "2" ? 2 : 1;
      S[n === 2 ? "firmness2" : "firmness"] = fm.dataset.firm;
      $$('[data-firm][data-firmside="' + n + '"]').forEach((c) => c.classList.toggle("sel", c.dataset.firm === fm.dataset.firm));
      summary(); return;
    }
    if (fm) {
      S.firmness = fm.dataset.firm;
      $$("[data-firm]").forEach((c) => c.classList.toggle("sel", c.dataset.firm === S.firmness));
      summary(); return;
    }

    const bs = e.target.closest("[data-base]");
    if (bs && !bs.disabled) {
      S.base = bs.dataset.base;
      $$(".mb-card--b").forEach((c) => { const on = c.dataset.base === S.base; c.classList.toggle("sel", on); c.setAttribute("aria-pressed", on); });
      B.mattresses.forEach((m) => { const f = $('[data-mattress="' + m.handle + '"] .mb-card__foot'); if (f) f.innerHTML = cardFoot(m); });
      summary(); return;
    }
  });

    paint();
  }

  boot(0);
})();
